import createVueApp from '@/common/createApp'

async function mount(props) {
  const { default: GeogridConfigViewer } = await import('@/vue_widgets/stats/geogrid_configs/index.vue')
  createVueApp(GeogridConfigViewer, { props })
}

Styxie.Initializers.StatsGeogridConfigs = {
  show: mount
}

Styxie.Initializers.StatsPublicSearchTermsConfigs = {
  show: (props) => mount({ ...props, customSearchTerms: true })
}
